// import React, { useEffect, useState } from 'react'
// import {
//     Page,
//     Text,
//     View,
//     Document,
//     StyleSheet,
//     Image,
// } from '@react-pdf/renderer'
// import Logo from '../../../assets/images/darkLogo.png'
// import dayjs from 'dayjs'

// const styles = StyleSheet.create({
//     page: {
//         padding: 24,
//         fontSize: 9,
//         fontFamily: 'Helvetica',
//         backgroundColor: '#fff',
//     },
//     header: {
//         flexDirection: 'row',
//         justifyContent: 'flex-end',
//         marginBottom: 16,
//         paddingBottom: 8,
//     },
//     logo: {
//         height: 18,
//     },
//     sectionTitle: {
//         fontSize: 12,
//         fontWeight: 'bold',
//         color: '#FFF',
//     },
//     subTitle: {
//         fontSize: 10,
//         marginBottom: 4,
//         color: '#444',
//     },
//     tableHeader: {
//         flexDirection: 'row',
//     },
//     tableRow: {
//         flexDirection: 'row',
//     },
//     tableCell: {
//         flex: 1,
//         paddingHorizontal: 4,
//         paddingVertical: 10,
//         borderWidth: 0.5,
//         borderColor: '#999999',
//     },
//     tableCellFlex5: {
//         flex: 5,
//         paddingHorizontal: 4,
//         paddingVertical: 10,
//         borderWidth: 0.5,
//         borderColor: '#999999',
//     },
//     tableCellDate: {
//         flex: 2, // wider column for dates
//         paddingHorizontal: 4,
//         paddingVertical: 10,
//         borderWidth: 0.5,
//         borderColor: '#999999',
//     },
//     bold: {
//         fontWeight: 'bold',
//     },
//     smallText: {
//         fontSize: 8,
//         color: '#666',
//     },
//     tableMainDiv: {
//         marginTop: 12,
//     },
//     totalSummaryRow: {
//         flexDirection: 'row',
//         backgroundColor: '#e6f7ff',
//         borderTopWidth: 1,
//         borderColor: '#91d5ff',
//     },
//     totalSummaryCell: {
//         flex: 1,
//         padding: 4,
//         borderWidth: 0.5,
//         borderColor: '#91d5ff',
//         fontWeight: 'bold',
//     },
//     totalSummaryCellFlex5: {
//         flex: 5,
//         padding: 4,
//         borderWidth: 0.5,
//         borderColor: '#91d5ff',
//         fontWeight: 'bold',
//     },
//     footer: {
//         position: 'absolute',
//         bottom: 10,
//         left: 24,
//         right: 24,
//         textAlign: 'center',
//         fontSize: 8,
//         color: '#888',
//     },
// })
// const hourMinuteSecond = (ms) => {
//     const h = Math.floor(ms / 3600000)
//     const m = Math.floor((ms % 3600000) / 60000)
//     const s = Math.floor((ms % 60000) / 1000)
//     return `${h}h ${m}m ${s}s`
// }

// const getTotalUserTime = (user) => {
//     return user?.list?.reduce((acc, item) => {
//         const duration = item?.totalLog || 0
//         return duration >= 60000 ? acc + duration : acc
//     }, 0)
// }

// const Footer = () => (
//     <View style={styles.footer} fixed>
//         <Text>{'\u00A9'} Confidential Document. Software Co & Client</Text>
//     </View>
// )

// const ReportDocument = ({ pdfData, selectPdfData }) => {
//     const [totalTime, setTotalTime] = useState(0)

//     useEffect(() => {
//         if (pdfData?.tableBody?.length > 0) {
//             const total = pdfData.tableBody.reduce(
//                 (sum, user) => sum + getTotalUserTime(user),
//                 0
//             )
//             setTotalTime(total)
//         }
//     }, [pdfData?.tableBody])

//     const tocList = (pdfData?.tableBody || [])
//         .map((user) => {
//             const assignee = selectPdfData?.assignees?.find(
//                 (a) => a?.value === user?._id?.assigneeId
//             )
//             return {
//                 name: assignee?.label || 'Unknown',
//                 total: hourMinuteSecond(getTotalUserTime(user)),
//                 page: '-',
//                 designation: assignee?.designation,
//             }
//         })
//         .sort((a, b) => a.name.localeCompare(b.name))

//     // const formatDateRanges = (dates) => {
//     //     const sortedDates = dates.sort((a, b) => a - b)
//     //     const ranges = []
//     //     let rangeStart = sortedDates[0]
//     //     let prev = sortedDates[0]

//     //     for (let i = 1; i <= sortedDates.length; i++) {
//     //         const current = sortedDates[i]
//     //         if (!current || current.diff(prev, "day") !== 1) {
//     //             if (rangeStart.isSame(prev, "day")) {
//     //                 ranges.push(rangeStart.format("DD"))
//     //             } else {
//     //                 ranges.push(`${rangeStart.format("DD")} – ${prev.format("DD")}`)
//     //             }
//     //             rangeStart = current
//     //         }
//     //         prev = current
//     //     }

//     //     const monthYear = sortedDates[0].format("MMM YYYY")
//     //     // Return array with monthYear appended to each range
//     //     return ranges.map(r => `${r} ${monthYear}`)
//     // }

//     const formatDateRanges = (dates) => {
//         if (!dates || dates.length === 0) return []

//         const sortedDates = [...dates].sort((a, b) => a.valueOf() - b.valueOf())
//         const ranges = []
//         let rangeStart = sortedDates[0]
//         let prev = sortedDates[0]

//         for (let i = 1; i <= sortedDates.length; i++) {
//             const current = sortedDates[i]

//             // break when gap in days OR month change
//             if (!current || current.diff(prev, "day") !== 1) {
//                 if (rangeStart.isSame(prev, "day")) {
//                     ranges.push(rangeStart.format("DD MMM YYYY"))
//                 } else {
//                     const sameMonth = rangeStart.isSame(prev, "month")
//                     if (sameMonth) {
//                         ranges.push(`${rangeStart.format("DD")} – ${prev.format("DD MMM YYYY")}`)
//                     } else {
//                         ranges.push(`${rangeStart.format("DD MMM YYYY")} – ${prev.format("DD MMM YYYY")}`)
//                     }
//                 }
//                 rangeStart = current
//             }
//             prev = current
//         }

//         return ranges
//     }

//     return (
//         <Document>
//             <Page size="A4" style={styles.page}>
//                 <View style={styles.header}>
//                     <Image src={Logo} style={styles.logo} />
//                 </View>

//                 <View style={styles.tableMainDiv}>

//                     <Text style={{ fontWeight: '700', fontSize: '16px', marginBottom: 5 }}>
//                         {selectPdfData?.project?.name || "Reports"}
//                     </Text>

//                     <Text style={[styles.subTitle, { marginBottom: 20 }]}>
//                         {dayjs(selectPdfData?.start).format('DD MMM YYYY')} - {dayjs(selectPdfData?.end).format('DD MMM YYYY')}
//                     </Text>
//                     <View style={styles.tableHeader}>
//                         <Text style={[styles.tableCellFlex5, styles.bold]}>Resource</Text>
//                         <Text style={[styles.tableCell, styles.bold, { textAlign: 'center' }]}>Hours</Text>
//                     </View>
//                     {tocList.map((item, idx) => (
//                         <View key={idx} style={[styles.tableRow, { alignItems: "center" }]}>
//                             <Text style={styles.tableCellFlex5}>
//                                 {item?.name + " "}
//                                 <Text style={{ marginLeft: 5, fontSize: 8, color: "#7c7c7cfa" }}>
//                                     {`(${item?.designation?.name})`}
//                                 </Text>
//                             </Text>
//                             <Text style={[styles.tableCell, { textAlign: 'center' }]}>{item.total}</Text>
//                         </View>
//                     ))}
//                     <View style={styles.totalSummaryRow}>
//                         <Text style={styles.totalSummaryCellFlex5}>Total Hours</Text>
//                         <Text style={[styles.totalSummaryCell, { textAlign: 'center' }]}>
//                             {hourMinuteSecond(totalTime)}
//                         </Text>
//                     </View>
//                 </View>

//                 {[...(pdfData?.tableBody || [])]
//                     .sort((a, b) => {
//                         const assigneeA = selectPdfData?.assignees?.find(x => x?.value === a?._id?.assigneeId)
//                         const assigneeB = selectPdfData?.assignees?.find(x => x?.value === b?._id?.assigneeId)
//                         return (assigneeA?.label || '').localeCompare(assigneeB?.label || '')
//                     })
//                     .map((user, userIdx) => {
//                         const assignee = selectPdfData?.assignees?.find(a => a?.value === user?._id?.assigneeId)
//                         if (!assignee) return null

//                         const rows = user?.list?.flatMap((task) =>
//                             Array.isArray(task?.list)
//                                 ? task.list.map((l) => ({
//                                     title: l?.title,
//                                     description: l?.description,
//                                     totalTaskLog: l?.totalLog || task?.totalLog,
//                                     start: task._id.startLogDate
//                                 }))
//                                 : []
//                         )

//                         // Group by title
//                         const grouped = {}
//                         rows.forEach(r => {
//                             const key = (r.title || '').trim().toLowerCase()
//                             if (!grouped[key]) {
//                                 grouped[key] = {
//                                     title: r.title || '',
//                                     description: r.description,
//                                     dates: [],
//                                     totalDuration: 0
//                                 }
//                             }
//                             grouped[key].dates.push(dayjs(r.start))
//                             grouped[key].totalDuration += r.totalTaskLog
//                         })
//                         const groupedRows = Object.values(grouped).map(g => {
//                             const rangesString = formatDateRanges(g.dates)
//                             return {
//                                 title: g.title,
//                                 description: g.description,
//                                 dateRange: rangesString,
//                                 totalDuration: g.totalDuration
//                             }
//                         })

//                         return (
//                             <View key={userIdx} wrap={false}>
//                                 <View style={{
//                                     backgroundColor: "#285FD0",
//                                     flexDirection: "row",
//                                     justifyContent: "space-between",
//                                     marginTop: 16,
//                                     marginBottom: 6,
//                                     padding: 8,
//                                     borderRadius: 2
//                                 }}>
//                                     <Text style={[styles.sectionTitle]}>
//                                         {assignee?.label + " "}
//                                         <Text style={{ marginLeft: 5, fontSize: 8, color: "#f3f3f3fa" }}>
//                                             {`(${assignee?.designation?.name})`}
//                                         </Text>
//                                     </Text>
//                                     <Text style={styles.sectionTitle}>
//                                         {hourMinuteSecond(getTotalUserTime(user))}
//                                     </Text>
//                                 </View>

//                                 <View style={styles.tableHeader}>
//                                     <Text style={[styles.tableCellFlex5, styles.bold]}>Task</Text>
//                                     <Text style={[styles.tableCellDate, styles.bold]}>Date</Text>
//                                     <Text style={[styles.tableCell, styles.bold]}>Duration</Text>
//                                 </View>

//                                 {groupedRows.filter(row => row.totalDuration >= 60000).map((row, idx) => (
//                                     <View key={idx} style={styles.tableRow} wrap={false}>
//                                         <Text style={styles.tableCellFlex5}>
//                                             <Text>{row.title}</Text>
//                                             {/* {row.description && (
//                                                 <Text style={styles.smallText}> {row.description}</Text>
//                                             )} */}
//                                         </Text>
//                                         <View style={styles.tableCellDate}>
//                                             {row.dateRange.map((dateStr, i) => (
//                                                 <Text key={i} style={{ marginBottom: i === row.dateRange.length - 1 ? 0 : 6 }}>
//                                                     {dateStr.trim()}
//                                                 </Text>
//                                             ))}
//                                         </View>
//                                         {/* <Text style={styles.tableCellDate}>
//   {row.dateRange.map((dateStr, i) => (
//     dateStr + (i === row.dateRange.length - 1 ? ',' : ', \n')
//   )).join('')}
// </Text> */}

//                                         <Text style={styles.tableCell}>{hourMinuteSecond(row.totalDuration)}</Text>
//                                     </View>
//                                 ))}
//                             </View>
//                         )
//                     })}

//                 <Footer />
//             </Page>
//         </Document>
//     )
// }

// export default ReportDocument

import React, { useEffect, useState } from 'react'
import {
    Page,
    Text,
    View,
    Document,
    StyleSheet,
    Image,
} from '@react-pdf/renderer'
import Logo from '../../../assets/images/darkLogo.png'
import dayjs from 'dayjs'

const styles = StyleSheet.create({
    page: {
        padding: 24,
        fontSize: 9,
        fontFamily: 'Helvetica',
        backgroundColor: '#fff',
    },
    header: {
        flexDirection: 'row',
        justifyContent: 'flex-end',
        marginBottom: 16,
        paddingBottom: 8,
    },
    logo: {
        height: 18,
    },
    sectionTitle: {
        fontSize: 12,
        fontWeight: 'bold',
        color: '#FFF',
    },
    subTitle: {
        fontSize: 10,
        marginBottom: 4,
        color: '#444',
    },
    tableHeader: {
        flexDirection: 'row',
    },
    tableRow: {
        flexDirection: 'row',
    },
    tableCell: {
        flex: 1,
        paddingHorizontal: 4,
        paddingVertical: 10,
        borderWidth: 0.5,
        borderColor: '#999999',
    },
    tableCellFlex5: {
        flex: 5,
        paddingHorizontal: 4,
        paddingVertical: 10,
        borderWidth: 0.5,
        borderColor: '#999999',
    },
    tableCellDate: {
        flex: 2,
        paddingHorizontal: 4,
        paddingVertical: 10,
        borderWidth: 0.5,
        borderColor: '#999999',
    },
    bold: {
        fontWeight: 'bold',
    },
    smallText: {
        fontSize: 8,
        color: '#666',
    },
    tableMainDiv: {
        marginTop: 12,
    },
    totalSummaryRow: {
        flexDirection: 'row',
        backgroundColor: '#e6f7ff',
        borderTopWidth: 1,
        borderColor: '#91d5ff',
    },
    totalSummaryCell: {
        flex: 1,
        padding: 4,
        borderWidth: 0.5,
        borderColor: '#91d5ff',
        fontWeight: 'bold',
    },
    totalSummaryCellFlex5: {
        flex: 5,
        padding: 4,
        borderWidth: 0.5,
        borderColor: '#91d5ff',
        fontWeight: 'bold',
    },
    footer: {
        position: 'absolute',
        bottom: 10,
        left: 24,
        right: 24,
        textAlign: 'center',
        fontSize: 8,
        color: '#888',
    },
})

const hourMinuteSecond = (ms) => {
    const h = Math.floor(ms / 3600000)
    const m = Math.floor((ms % 3600000) / 60000)
    const s = Math.floor((ms % 60000) / 1000)
    return `${h}h ${m}m ${s}s`
}

// Filtered getTotalUserTime: only sum durations >= 1 minute
const getTotalUserTime = (user) => {
    return user?.list?.reduce((acc, item) => {
        const duration = item?.totalLog || 0
        return duration >= 60000 ? acc + duration : acc
    }, 0)
}

const Footer = () => (
    <View style={styles.footer} fixed>
        <Text>{'\u00A9'} Confidential Document. Software Co & Client</Text>
    </View>
)

const ReportDocument = ({ pdfData, selectPdfData }) => {
    // const [totalTime, setTotalTime] = useState(0)

    // Filter users with totalTime > 0
    const filteredUsers = (pdfData?.tableBody || []).filter(
        (user) => getTotalUserTime(user) > 0
    )

    const totalTime = filteredUsers.reduce(
        (sum, user) => sum + getTotalUserTime(user),
        0
    )
    // useEffect(() => {
    //     if (filteredUsers.length > 0) {
    //         const total = filteredUsers.reduce(
    //             (sum, user) => sum + getTotalUserTime(user),
    //             0
    //         )
    //         setTotalTime(total)
    //     }
    // }, [pdfData?.tableBody])

    const tocList = filteredUsers
        .map((user) => {
            const assignee = selectPdfData?.assignees?.find(
                (a) => a?.value === user?._id?.assigneeId
            )
            return {
                name: assignee?.label || 'Unknown',
                total: hourMinuteSecond(getTotalUserTime(user)),
                page: '-',
                designation: assignee?.designation,
            }
        })
        .sort((a, b) => a.name.localeCompare(b.name))

    const formatDateRanges = (dates) => {
        if (!dates || dates.length === 0) return []

        const sortedDates = [...dates].sort((a, b) => a.valueOf() - b.valueOf())
        const ranges = []
        let rangeStart = sortedDates[0]
        let prev = sortedDates[0]

        for (let i = 1; i <= sortedDates.length; i++) {
            const current = sortedDates[i]

            // break when gap in days OR month change
            if (!current || current.diff(prev, "day") !== 1) {
                if (rangeStart.isSame(prev, "day")) {
                    ranges.push(rangeStart.format("DD MMM YYYY"))
                } else {
                    const sameMonth = rangeStart.isSame(prev, "month")
                    if (sameMonth) {
                        ranges.push(`${rangeStart.format("DD")} – ${prev.format("DD MMM YYYY")}`)
                    } else {
                        ranges.push(`${rangeStart.format("DD MMM YYYY")} – ${prev.format("DD MMM YYYY")}`)
                    }
                }
                rangeStart = current
            }
            prev = current
        }

        return ranges
    }

    return (
        <Document>
            <Page size="A4" style={styles.page}>
                <View style={styles.header}>
                    <Image src={Logo} style={styles.logo} />
                </View>

                <View style={styles.tableMainDiv}>
                    <Text style={{ fontWeight: '700', fontSize: '16px', marginBottom: 5 }}>
                        {selectPdfData?.project?.name || "Reports"}
                    </Text>

                    <Text style={[styles.subTitle, { marginBottom: 20 }]}>
                        {dayjs(selectPdfData?.start).format('DD MMM YYYY')} - {dayjs(selectPdfData?.end).format('DD MMM YYYY')}
                    </Text>

                    <View style={styles.tableHeader}>
                        <Text style={[styles.tableCellFlex5, styles.bold]}>Resource</Text>
                        <Text style={[styles.tableCell, styles.bold, { textAlign: 'center' }]}>Hours</Text>
                    </View>

                    {tocList.map((item, idx) => (
                        <View key={idx} style={[styles.tableRow, { alignItems: "center" }]}>
                            <Text style={styles.tableCellFlex5}>
                                {item?.name + " "}
                                <Text style={{ marginLeft: 5, fontSize: 8, color: "#7c7c7cfa" }}>
                                    {`(${item?.designation?.name})`}
                                </Text>
                            </Text>
                            <Text style={[styles.tableCell, { textAlign: 'center' }]}>{item.total}</Text>
                        </View>
                    ))}

                    <View style={styles.totalSummaryRow}>
                        <Text style={styles.totalSummaryCellFlex5}>Total Hours</Text>
                        <Text style={[styles.totalSummaryCell, { textAlign: 'center' }]}>
                            {hourMinuteSecond(totalTime)}
                        </Text>
                    </View>
                </View>

                {filteredUsers
                    .sort((a, b) => {
                        const assigneeA = selectPdfData?.assignees?.find(x => x?.value === a?._id?.assigneeId)
                        const assigneeB = selectPdfData?.assignees?.find(x => x?.value === b?._id?.assigneeId)
                        return (assigneeA?.label || '').localeCompare(assigneeB?.label || '')
                    })
                    .map((user, userIdx) => {
                        const assignee = selectPdfData?.assignees?.find(a => a?.value === user?._id?.assigneeId)
                        if (!assignee) return null

                        const rows = user?.list?.flatMap((task) =>
                            Array.isArray(task?.list)
                                ? task.list
                                    // ✅ Filter out tasks < 1 minute immediately
                                    .filter((l) => (l?.totalLog || task?.totalLog) >= 60000)
                                    .map((l) => ({
                                        title: l?.title,
                                        description: l?.description,
                                        totalTaskLog: l?.totalLog || task?.totalLog,
                                        start: task._id.startLogDate,
                                    }))
                                : []
                        )

                        // Group by title
                        const grouped = {}
                        rows.forEach(r => {
                            const key = (r.title || '').trim().toLowerCase()
                            if (!grouped[key]) {
                                grouped[key] = {
                                    title: r.title || '',
                                    description: r.description,
                                    dates: [],
                                    totalDuration: 0,
                                }
                            }
                            grouped[key].dates.push(dayjs(r.start))
                            grouped[key].totalDuration += r.totalTaskLog
                        })

                        const groupedRows = Object.values(grouped)
                            .map(g => {
                                const rangesString = formatDateRanges(g.dates)
                                return {
                                    title: g.title,
                                    description: g.description,
                                    dateRange: rangesString,
                                    totalDuration: g.totalDuration,
                                }
                            })
                            // ✅ Keep only tasks ≥ 1 minute (final safeguard)
                            .filter(row => row.totalDuration >= 60000)

                        if (groupedRows.length === 0) return null

                        return (
                            <View key={userIdx} minPresenceAhead={150} >
                                {/* User Heading */}
                                <View style={{
                                    backgroundColor: "#285FD0",
                                    flexDirection: "row",
                                    justifyContent: "space-between",
                                    marginTop: 16,
                                    marginBottom: 6,
                                    padding: 8,
                                    borderRadius: 2
                                }}>
                                    <Text style={[styles.sectionTitle]}>
                                        {assignee?.label + " "}
                                        <Text style={{ marginLeft: 5, fontSize: 8, color: "#f3f3f3fa" }}>
                                            {`(${assignee?.designation?.name})`}
                                        </Text>
                                    </Text>
                                    <Text style={styles.sectionTitle}>
                                        {hourMinuteSecond(getTotalUserTime(user))}
                                    </Text>
                                </View>

                                {/* Table Header */}
                                <View style={styles.tableHeader}>
                                    <Text style={[styles.tableCellFlex5, styles.bold]}>Task</Text>
                                    <Text style={[styles.tableCellDate, styles.bold]}>Date</Text>
                                    <Text style={[styles.tableCell, styles.bold]}>Duration</Text>
                                </View>

                                {/* Task Rows */}
                                {groupedRows.map((row, idx) => (
                                    <View key={idx} style={styles.tableRow} wrap={false}>
                                        <Text style={styles.tableCellFlex5}>{row.title}</Text>
                                        <View style={styles.tableCellDate}>
                                            {row.dateRange.map((dateStr, i) => (
                                                <Text
                                                    key={i}
                                                    style={{ marginBottom: i === row.dateRange.length - 1 ? 0 : 6 }}
                                                >
                                                    {dateStr.trim()}
                                                </Text>
                                            ))}
                                        </View>
                                        <Text style={styles.tableCell}>
                                            {hourMinuteSecond(row.totalDuration)}
                                        </Text>
                                    </View>
                                ))}
                            </View>
                        )
                    })}

                <Footer />
            </Page>
        </Document>
    )
}

export default ReportDocument
